import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';
import {
  CODE_ERRORS,
  ENDPOINT_API_PATH,
} from '../Definitions/ResetPasswordDef';

const autoGenerateSuccess = (
  type: string,
  value: string,
  requestValue: any,
) => {
  const requestLogin =
    type === 'MEMBER'
      ? { memberNumber: value }
      : type === 'EMAIL'
      ? { email: value }
      : {
          document: {
            type,
            value,
          },
        };

  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        ...requestLogin,
        ...requestValue,
      },
    },
    configResponse: {
      status: 200,
      data: {
        serviceRequestId: '1-128182633147',
        message: 'Sucesso na solicitação de Reset de Senha',
      },
      headers: {},
    },
  };
  return validateSuccess;
};

const generatedSuccessMocks = () => {
  const inputs = [
    {
      type: 'EMAIL',
      value: MocksDef.EMAIL,
      params: {
        otherEmail: MocksDef.OTHER_EMAIL_SMILES,
      },
    },
    {
      type: 'CPF',
      value: MocksDef.DOCUMENT_TYPE.CPF,
      params: {
        otherEmail: MocksDef.OTHER_EMAIL_SMILES,
      },
    },
    {
      type: 'MEMBER',
      value: MocksDef.MEMBER_NUMBER,
      params: {
        otherEmail: MocksDef.OTHER_EMAIL_SMILES,
      },
    },
    {
      type: 'EMAIL',
      value: MocksDef.EMAIL,
      params: { contactType: 'EMAIL' },
    },
    {
      type: 'CPF',
      value: MocksDef.DOCUMENT_TYPE.CPF,
      params: {
        contactType: 'EMAIL',
      },
    },
    {
      type: 'MEMBER',
      value: MocksDef.MEMBER_NUMBER,
      params: {
        contactType: 'EMAIL',
      },
    },
    {
      type: 'EMAIL',
      value: MocksDef.EMAIL,
      params: {
        contactType: 'SMS',
      },
    },
    {
      type: 'CPF',
      value: MocksDef.DOCUMENT_TYPE.CPF,
      params: {
        contactType: 'SMS',
      },
    },
    {
      type: 'MEMBER',
      value: MocksDef.MEMBER_NUMBER,
      params: {
        contactType: 'SMS',
      },
    },
  ];

  return inputs.map((e) => autoGenerateSuccess(e.type, e.value, e.params));
};

const autoGenerate = (
  email: string,
  contactType: string | undefined,
  otherEmail: string | undefined,
) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body: contactType
            ? {
                contactType,
                email: `${index}-${email}`,
              }
            : {
                otherEmail,
                email: `${index}-${email}`,
              },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
            stack: 'STACK do erro obtido pelo servidor',
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};

const autoGenerateErrorsMock = () => {
  const responseContactTypeEMAIL = autoGenerate(
    MocksDef.EMAIL,
    'EMAIL',
    undefined,
  );
  const responseContactTypeSMS = autoGenerate(MocksDef.EMAIL, 'SMS', undefined);
  const responseOtherEmail = autoGenerate(
    MocksDef.EMAIL,
    undefined,
    MocksDef.OTHER_EMAIL_SMILES,
  );
  return [
    ...responseContactTypeEMAIL,
    ...responseContactTypeSMS,
    ...responseOtherEmail,
  ];
};

const errorsGenerated = autoGenerateErrorsMock();
const successGenerated = generatedSuccessMocks();

const ResetPassword = [...errorsGenerated, ...successGenerated];
export default ResetPassword;
